import _ from 'underscore';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { getHotelCenterUtils } from '@bingads-webui-campaign/hotel-center-utils';
import template from './view-template.pug';
import { getBidMultiplierView } from '../single-multiplier-view/view';

export const getCheckInDayMultipliersView = ({
  i18n, state, pageContext, multiplierSchema,
}) => {
  const { bidMultiplierUtils } = getHotelCenterUtils({ i18n, state });
  const { BidMultiplierView } = getBidMultiplierView({ i18n, pageContext, multiplierSchema });
  const {
    serializeBidMultipliers,
    weekDayMap,
  } = bidMultiplierUtils;

  /**
   * Shared view for Hotel Ads bid strategy setup section
   * @extends DeterministicView
   */

  class CheckInDayMultipliersView extends DeterministicView {
    initialize() {
      _.each(_.keys(weekDayMap), (key) => {
        this.setChild(`${key.toLowerCase()}-bid-multiplier`, this.getBidMultiplierView({
          value: key,
          text: i18n.getString(weekDayMap[key]),
        }));
      });
    }

    getBidMultiplierView(options) {
      const view = new BidMultiplierView({
        type: 'checkInDay',
        value: options.value,
        text: options.text,
      });

      return view;
    }

    get template() {
      return template;
    }

    getState() {
      const checkInDayMultipliersState = [];

      _.each(_.keys(weekDayMap), (key) => {
        checkInDayMultipliersState.push(this.getChild(`${key.toLowerCase()}-bid-multiplier`).getState());
      });

      if (_.findWhere(checkInDayMultipliersState, { isValid: false })) {
        return {
          isValid: false,
          bidMultipliers: _.noop(),
        };
      }

      return {
        isValid: true,
        bidMultipliers: serializeBidMultipliers(checkInDayMultipliersState),
      };
    }

    setState(options = {}) {
      const { isUseParent } = options;

      if (!_.isUndefined(isUseParent)) {
        _.each(_.keys(weekDayMap), (key) => {
          this.getChild(`${key.toLowerCase()}-bid-multiplier`).setState({ isUseParent });
        });
      }

      _.each(_.keys(weekDayMap), (key) => {
        if (options &&
          options[key] &&
          (options[key].strategy || !_.isUndefined(options[key].factor))) {
          this.getChild(`${key.toLowerCase()}-bid-multiplier`).setState({
            strategy: options[key].strategy,
            factor: options[key].factor,
          });
        }
      });

      return this;
    }
  }

  return {
    CheckInDayMultipliersView,
  };
};
